/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-useless-concat */
/* eslint-disable react/button-has-type */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const columns = [
  { field: 'RMA', headerName: 'RMA', width: 200, headerAlign: 'left', align: 'left' },
  { field: 'RMAType', headerName: 'RMA Type', width: 200, headerAlign: 'left', align: 'left' },
  { field: 'TrackingNo',
    headerName: 'Tracking No',
    valueFormatter: ({ value }) => `${(value).valueOf()}` + '\t',
    width: 350,
    type: 'string',
    headerAlign: 'left',
    align: 'left' }, //  valueFormatter: ({ value }) => `s${(value).toString()}`
  { field: 'BLKReceiving', headerName: 'BLK Receiving', width: 200, headerAlign: 'left', align: 'left', valueFormatter: ({ value }) => `${(value).valueOf()}` + '\t' },
  { field: 'KIT',
    headerName: 'KIT',
    width: 250,
    headerAlign: 'left',
    align: 'left',
    renderCell: (params) => (
      <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
        {params.value}
      </div>
    ),
    valueFormatter: ({ value }) => `${(value).valueOf()}` + '\t' },
  { field: 'SKU', headerName: 'SKU', width: 200, headerAlign: 'left', align: 'left' },
  { field: 'CoreItem', headerName: 'Core Item', width: 200, headerAlign: 'left', align: 'left' },
  { field: 'ExpectedQty', headerName: 'Expected Qty', width: 100, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'PassQty', headerName: 'Pass Qty', width: 100, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'ScrapQty', headerName: 'Scrap Qty', width: 100, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'CreatedDate', headerName: 'Created Date', width: 150, type: 'Date', headerAlign: 'left', align: 'left' },
  { field: 'ReceivingCategory', headerName: 'Receving Category', width: 200, headerAlign: 'left', align: 'left' },
  { field: 'ReceivingType', headerName: 'Receving Type', width: 200, headerAlign: 'left', align: 'left' },

];

const DailyProduct = () => {
  const strt = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(strt);
  const [tableData, setTableData] = useState([]);
  const { activeMenu } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(strt); // for compulsory dates
    }
  }, [startDate, endDate]);
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (JSON.parse(localStorage.getItem('loginID'))) {
        InboundTable();
      }
    }
  }, []);

  const InboundTable = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    // Thu Jan 01 1970 05:30:00 GMT+0530
    const raw = JSON.stringify({
      UserId: JSON.parse(localStorage.getItem('loginID')) === null || undefined ? null : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'Daily Product Returns Activity',
      FromDate: startDate,
      ToDate: endDate,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(`${variables.BASE_URL}DailyProductReturnsActivity`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (JSON.parse(result)?.IsSuccess !== false && JSON.parse(result)?.IsAuthorize !== false) {
          setTableData(JSON.parse(result).DailyProductReturnsActivity);
        } else if (JSON.parse(result)?.IsSuccess !== true && JSON.parse(result)?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };

  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend')?.focus();
    }
  };

  const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={InboundTable}
          />
        </div>
        <div>
          <div className="container-fluid">
            <div id="table_container">
              <Paper className="table_backpaper">
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <CustomDataGrid
                      name="Daily Product Return"
                      tableData={tableData}
                      column={columns}
                    />
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyProduct;
